var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.773043 10.2783L0.751583 3.65674L40.5082 3.52789C40.6425 3.52745 40.7518 3.6481 40.7522 3.79737L40.772 9.87842C40.7724 10.0277 40.664 10.149 40.5297 10.1495L0.773043 10.2783Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.803213 19.6023L0.781752 12.9807L26.6783 12.8968C26.8126 12.8963 26.9218 13.017 26.9223 13.1663L26.942 19.2473C26.9425 19.3966 26.834 19.5179 26.6997 19.5184L0.803213 19.6023Z",
    fill: "#003F7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833452 28.9267L0.811991 22.3051L17.8332 22.2499C17.9675 22.2495 18.0767 22.3701 18.0772 22.5194L18.0969 28.6005C18.0974 28.7497 17.9889 28.8711 17.8546 28.8715L0.833452 28.9267Z",
    fill: "#003F7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863601 38.251L0.84214 31.6294L11.9059 31.5936C12.0402 31.5931 12.1495 31.7138 12.1499 31.863L12.1697 37.9441C12.1701 38.0934 12.0617 38.2147 11.9274 38.2151L0.863601 38.251Z",
    fill: "#003F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.742386 0.818726L0.872 40.8185",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.a2a4147b460aa870fdc9c9b14151275e.svg";
export { ForwardRef as ReactComponent };